<template>
    <div>
       	<label class="lable-full-width">Passport size photo*</label>
        <input type="file"  ref="photo" @change="getFile" hidden data-from='passport_size_photo'/>
        <label class="choose-btn" @click="$refs.photo.click()">Choose file</label>
        <span id="file-chosen">{{f_data.passport_size_photo}}</span>
    </div>
</template>
<script>
import file from '../services/fileupload'
import ls from '../services/ls'
export default {
    name:'photo_upload',
    props:['propdata','from_key'],
    watch:{
        propdata:function (data){
            this.f_data = data
        }
    },
    data() {
        return{
            f_data:{},
        }
    },
    methods: {
        getFile(){
             let formData = new FormData();
            for (var i = 0; i < this.$refs.photo.files.length; i++) {
                let file = this.$refs.photo.files[i];
                formData.append('files[' + i + ']', file);
            }
            formData.append('subscription_id', this.propdata.subscribtion_id)
            formData.append('slug', this.propdata.type)
            formData.append('folder_id', this.propdata.folder_id)
            formData.append('session_user', ls.get('_u_unique'));
            formData.append('label', 'Passport size photo');
            file.uploadProofs(formData)
            .then(response =>{
                 this.$emit("UpdateFilePath", {
                    	src: 'passport_size_photo',
                    	url: response.data.file_url,
                    	action:this.from_key
                });
            })
        }
    }
}
</script>